import mixpanel from 'mixpanel-browser';
import { ref } from 'vue';

const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_PROJECT_KEY;
const isInitialized = ref(false);
const distinctId = ref(null);
const applicationName = 'timao';

export function useMixpanel() {
    if (!isInitialized.value && MIXPANEL_TOKEN) {
        mixpanel.init(MIXPANEL_TOKEN);
        distinctId.value = mixpanel.get_distinct_id();

        isInitialized.value = true;
    }

    /**
     * Track event in Mixpanel
     * @param {string} eventName - The name of the event
     * @param {object} props - Additional event properties
     */
    const trackEvent = (eventName, props = {}) => {
        mixpanel.track(eventName, {
            distinct_id: distinctId.value,
            application_name: applicationName,
            ...props,
        });
    };

    /**
     * Identify a user by associating them with the existing `distinct_id`
     * @param {string} userId - Unique user ID
     * @param {object} [properties={}] - User properties
     */
    const identifyUser = (userId, properties = {}) => {
        mixpanel.identify(userId);
        mixpanel.people.set(properties);
        distinctId.value = userId;
    };

    /**
     * Reset Mixpanel user session
     */
    const resetUser = () => {
        mixpanel.reset();
        distinctId.value = mixpanel.get_distinct_id();
    };

    return {
        trackEvent,
        identifyUser,
        resetUser,
        distinctId,
    };
}
